import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetStockListPaginated = () =>
  useMutation({
    mutationFn: (data) => client(`resources/stock`, { data }),
  });

export const useAddStock = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/stock/add`, {
        data,
        successMessage: "Stock has been added successfully",
      }),
  });
export const useAddStockBulk = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/stock/add/bulk`, {
        data,
        successMessage: "Stock has been added successfully",
      }),
  });

export const useEditStock = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/stock/edit`, {
        data,
        successMessage: "Stock has been updated successfully",
      }),
  });

export const useGetStock = () =>
  useMutation({
    mutationFn: (data) => client(`resources/stock/${data}`),
  });
